import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    createShare: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Tooltip and aria-label for creating a share */
            createShare: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CreateShareButton.createShare?c=34u6g57b1fztn", defaultMessage: "Create Share Link" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
